import { render } from "./FloatingCompoundTable.vue?vue&type=template&id=4f655f41"
import script from "./FloatingCompoundTable.vue?vue&type=script&lang=js"
export * from "./FloatingCompoundTable.vue?vue&type=script&lang=js"

import "./FloatingCompoundTable.vue?vue&type=style&index=0&id=4f655f41&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__